import React from 'react';

import { Button } from '@components/Button';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  headerContainer: {
    ...common.flexInline,
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 40,
  },
  button: {
    ...common.bigText,
    width: 120,
  },
}));

export interface CargoTrackingHeaderProps {
  title: React.ReactNode;
  buttonTitle: React.ReactNode;
  onClickButton?: () => void;
}

export const CargoTrackingHeader: React.FC<CargoTrackingHeaderProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { title, buttonTitle, onClickButton } = props;

  return (
    <div className={classes.headerContainer}>
      <div className={clsx(classes.largeText, classes.fontWeight600, classes.textGray800)}>
        {title}
      </div>

      <Button
        color="primary"
        text={buttonTitle}
        className={clsx(classes.button)}
        onClick={onClickButton}
      />
    </div>
  );
};
